/**
 * Shared navigation types for eQuote
 */

export enum AppRoute {
  M01SplashScreen = 'M01SplashScreen',
  M02LoginScreen = 'M02LoginScreen',
  M03HomeScreen = 'M03HomeScreen',
  M04ProductListScreen = 'M04ProductListScreen',
  M05ProductDetailScreen = 'M05ProductDetailScreen',
  M06SelectCustomerScreen = 'M06SelectCustomerScreen',
  M06ConfigureProductScreen = 'M06ConfigureProductScreen',
  M06InputCustomerScreen = 'M06InputCustomerScreen',
  M07ResultScreen = 'M07ResultScreen',
  M08CompareScreen = 'M08CompareScreen',
  M09PdfScreen = 'M09PdfScreen',
  M10SaveCustomerScreen = 'M10SaveCustomerScreen',
  M11HistoryScreen = 'M11HistoryScreen',
  M12ProfileScreen = 'M12ProfileScreen',
  M13ShareScreen = 'M13ShareScreen',
  M14NotesScreen = 'M14NotesScreen',
  M15CustomerListScreen = 'M15CustomerListScreen',
  M16CustomerDetailScreen = 'M16CustomerDetailScreen',
  M17FinancialSurveyScreen = 'M17FinancialSurveyScreen',
}

export type RootStackParamList = {
  M01SplashScreen: undefined;
  M02LoginScreen: undefined;
  M03HomeScreen: undefined;
  M04ProductListScreen: undefined;
  M05ProductDetailScreen: { productId?: string } | undefined;
  M06SelectCustomerScreen: {
    illustrationId?: string;
    productId?: string;
    customerId?: string;
    customerName?: string;
    customerAge?: number;
    customerGender?: 'Nam' | 'Nữ';
    customerPhone?: string;
    customerEmail?: string;
    customerDob?: string;
  } | undefined;
  M06ConfigureProductScreen: {
    illustrationId?: string;
    productId?: string;
    customerName?: string;
    customerAge?: number;
    customerGender?: 'Nam' | 'Nữ';
    customerDob?: string;
  } | undefined;
  M06InputCustomerScreen: {
    illustrationId?: string;
    productId?: string;
    customerName?: string;
    customerAge?: number;
    customerGender?: 'Nam' | 'Nữ';
    customerPhone?: string;
    customerEmail?: string;
    customerDob?: string;
  } | undefined;
  M07ResultScreen: {
    illustrationId?: string;
    productId?: string;
    customerName?: string;
    customerAge?: number;
    customerGender?: 'Nam' | 'Nữ';
    sumAssured?: string;
    term?: string;
    freq?: string;
    estPremium?: string;
    selectedRiders?: string[];
    /** Đầu tư thêm (Top-up) — mặc định 0 */
    topUpAmount?: number;
    /** Năm bắt đầu đóng thêm — mặc định 1 */
    topUpStartYear?: number;
    /** Số năm đóng thêm — mặc định 0 */
    topUpDuration?: number;
    /** R5 Bảo Thân Xanh mode — 'complimentary' (Tặng kèm, 0đ) | 'attached' (Đính kèm, 796k) */
    r5Mode?: 'complimentary' | 'attached';
    // Custom configurations
    r1Package?: 'silver' | 'gold' | 'platinum';
    r2LimitCuoi?: number;
    r2LimitSom?: number;
    r2LimitDacBiet?: number;
    r3DailyAllowance?: number;
    r4PhysicalLimit?: number;
    r5SumAssured?: number;
    r5Term?: '20_years' | 'whole_life';
    riderPremiumOverrides?: Record<string, number>;
  } | undefined;
  M08CompareScreen: { illustrationId?: string } | undefined;
  M09PdfScreen: { illustrationId?: string } | undefined;
  M10SaveCustomerScreen: { illustrationId?: string } | undefined;
  M11HistoryScreen: undefined;
  M12ProfileScreen: undefined;
  M13ShareScreen: { data?: string } | undefined; // base64 encoded illustration parameters
  M14NotesScreen: { customerName?: string } | undefined;
  M15CustomerListScreen: undefined;
  M16CustomerDetailScreen: { customerId: string } | undefined;
  M17FinancialSurveyScreen: undefined;
};



